import { Card } from '@material-ui/core';
import type { FC } from 'react';
import HotelSummaryItem from './HotelSummaryItem';
import TicketSummaryItem from './TicketSummaryItem';
import TransferSummaryItem from './TransferSummaryItem';
import InsuranceSummaryItem from './InsuranceSummaryItem';
import { ProductType } from '../types';
import Totals from './Totals/Totals';
import ExtraSummaryItem from './ExtraSummaryItem';
import { PackageState } from '../hooks/types';

interface Props {
  packageState: PackageState;
  onDelete?: (id: string, productType: ProductType) => void;
  onItemClick?: (id: string, productType: ProductType) => void;
}

const Summary: FC<Props> = ({ packageState, onDelete, onItemClick }) => {
  return (
    <Card className="min-h-[30rem] border border-gray-300 flex flex-col">
      <div className="text-xl font-bold px-3 py-2">Summary</div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto space-y-2">
        {packageState.hotels.map((hotel) => (
          <HotelSummaryItem
            key={hotel.id}
            onEdit={() => onItemClick?.(hotel?.id || '', 'hotel')}
            onDelete={
              onDelete
                ? () => {
                    onDelete?.(hotel?.id || '', 'hotel');
                  }
                : undefined
            }
            hotel={hotel}
          />
        ))}
        {packageState.tickets.map((ticket) => (
          <TicketSummaryItem
            key={ticket.id}
            onEdit={() => onItemClick?.(ticket?.id || '', 'ticket')}
            onDelete={
              onDelete
                ? () => {
                    onDelete?.(ticket?.id || '', 'ticket');
                  }
                : undefined
            }
            ticket={ticket}
          />
        ))}
        {packageState.transfers.map((transfer) => (
          <TransferSummaryItem
            key={transfer.id}
            onEdit={() => onItemClick?.(transfer?.id || '', 'transfer')}
            onDelete={
              onDelete
                ? () => {
                    onDelete?.(transfer?.id || '', 'transfer');
                  }
                : undefined
            }
            transfer={transfer}
          />
        ))}
        {packageState.insurances.map((insurance) => (
          <InsuranceSummaryItem
            key={insurance.id}
            onEdit={() => onItemClick?.(insurance?.id || '', 'insurance')}
            onDelete={
              onDelete
                ? () => {
                    onDelete?.(insurance?.id || '', 'insurance');
                  }
                : undefined
            }
            insurance={insurance}
          />
        ))}
        {packageState.extras.map((extra) => (
          <ExtraSummaryItem
            key={extra.id}
            onEdit={() => onItemClick?.(extra?.id || '', 'extra')}
            onDelete={
              onDelete
                ? () => {
                    onDelete?.(extra?.id || '', 'extra');
                  }
                : undefined
            }
            extra={extra}
          />
        ))}
      </div>

      {/* Footer */}
      <div className="border-t border-gray-200 px-3 py-2">
        <Totals netTotal={packageState.netTotal} />
      </div>
    </Card>
  );
};

export default Summary;
